import { z } from "@core/zod";

export type Stage = "prod" | "test" | `dev${number}`;

export const StageSchema = z
  .string()
  .refine(
    (value): value is Stage =>
      value === "prod" || value === "test" || /^dev\d+$/u.test(value),
    "Invalid stage: expected 'prod', 'test', or 'dev' followed by a number",
  );
